export default "__VITE_ASSET__5f037fa2__"